import type { NewApptState } from '../types';

const selectServiceCustomTotalDuration = (state: NewApptState) => state.newAppt.services.custom.totalDuration;

export { selectServiceCustomTotalDuration };
